import React from 'react';

const WhoThisIsForSection = () => {
  const audiences = [
    {
      title: "CFOs/FDs",
      description: "Accountable for the integrity of the control framework.",
      borderColor: "bg-[#22C55E]",
      icon: "account_balance"
    },
    {
      title: "PE-Backed",
      description: "Ensuring value protection and governance for investors.",
      borderColor: "bg-[#FFD100]",
      icon: "trending_up"
    },
    {
      title: "Listed/AIM",
      description: "Navigating public market compliance and investor confidence.",
      borderColor: "bg-[#F87171]",
      icon: "public"
    },
    {
      title: "Audit Prep",
      description: "Reducing the time and cost of annual external audit cycles.",
      borderColor: "bg-[#0077C8]",
      icon: "description"
    }
  ];

  return (
    <section className="py-24 px-6 bg-[#F9FAFB]">
      <div className="max-w-[960px] mx-auto text-center">
        <h2 className="text-3xl font-extrabold mb-16 text-[#050B15]">Designed for organisations under real scrutiny.</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {audiences.map((audience, index) => (
            <div key={index} className="p-8 text-left bg-white rounded-xl shadow-sm h-full relative overflow-hidden group hover:shadow-md transition-all">
              <div className={`absolute bottom-0 left-0 right-0 h-1 ${audience.borderColor} group-hover:h-2 transition-all`}></div>
              <div className="flex items-center gap-3 mb-3">
                <span className={`material-symbols-outlined text-2xl ${audience.borderColor.replace('bg-', 'text-')}`}>{audience.icon}</span>
                <h4 className="text-lg font-extrabold text-[#050B15]">{audience.title}</h4>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">{audience.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoThisIsForSection;
